export { FiltersModule } from './filters.module';
export * from './reducer';
export * from './actions';
export * from './services';
export * from './models';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/index.ts